import "../../assets/styles/redirect-card.scss";
import { Box, Card, CardContent, Link, Typography } from "@mui/material";
import React from "react";
import ArrowRightIcon from "../../assets/icons/arrowRight";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function RedirectCard({
  url,
  icon,
  title,
  subtitle,
  dataTestId = "redirect_card"
}) {
  const theme = useTheme();
  const isTabletLandscape = useMediaQuery(theme.breakpoints.down(1371));
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: "16px",
        "&:hover": {
          background: "var(--new-accent-hover) !important",
          transition: "all 0.15s ease-in"
        },
        "&:focus": {
          background: "var(--new-accent-hover) !important"
        },
        "&:focus-within": {
          background: "var(--new-accent-hover) !important"
        }
      }}
      className="redirect-card card-main"
      data-testid={`${dataTestId}`}
    >
      <Link
        href={url}
        target="_blank"
        style={{ height: "100%", textDecoration: "none" }}
      >
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
            p: "16px",
            pt: "12px",
            pb: "12px",
            marginTop: "-1px"
          }}
        >
          <Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: isTabletLandscape ? "16px" : "20px",
                fontWeight: "600",
                lineHeight: "28px",
                color: "var(--font-extreme-default)",
                margin: 0,
                overflowWrap: "break-word",
                wordBreak: "normal",
                hyphens: "manual"
              }}
              data-testid={`${dataTestId}_heading`}
            >
              {title}
            </Typography>
            <Typography
              sx={{
                marginTop: "12px",
                fontSize: isTabletLandscape ? "14px" : "16px",
                lineHeight: "24px",
                color: "var(--font-subtle-default)",
                overflowWrap: "break-word",
                wordBreak: "break-word",
                hyphens: "auto"
              }}
              data-testid={`${dataTestId}_text`}
            >
              {subtitle}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              mt: 2
            }}
          >
            <Box
              className="chevron-button"
              data-testid={`${dataTestId}_arrow_button`}
            >
              <ArrowRightIcon />
            </Box>
          </Box>
        </CardContent>
      </Link>
    </Card>
  );
}
